module.exports = __webpack_public_path__ + "img/message.e344f5d5.png";